<template>

    <section id="portfoliosection">
    
        <article id="portfolio">
                <div class="container-fluid portfolio">
                    <h1 class="section-header">Portfolio</h1>

                    <!-- start of filters  -->
                    <!-- <div class="row filters">
                        <ul class="list-inline mx-auto">
                            <li
                                
                                class="list-inline-item filter"
                            >
                                <a
                                class="nav-item"
                                
                                >{{  }}</a
                                >
                            </li>
                        </ul>
                    </div> -->
                
                    <!-- end of filters  -->
                

                    <!-- start of projects container  -->

                        <!-- <div id="skills-container" class="row skills-cont">

                            <div
                                data-aos="fade-down"
                                data-aos-duration="1000"
                                data-aos-anchor-placement="bottom-bottom"
                                
                                class="col-sm-6 col-md-2 flex-col"
                            >

                                <div class="skills-item">
                                
                                <div class="overlay">
                                    
                                    <div class="skills-item-content">
                                        <h3>{{  }}</h3>
                                    </div>
                                    
                                </div>
                                </div>
                            </div>
                        </div> -->

                        <div 
                        class="carousel-projects row"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-anchor-placement="bottom-bottom"
                            >  
                            <div id="carouselExampleIndicators" class="carousel slide col-sm-12 col-md-12 flex-col" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                </ol>

                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                       <!--  <img class="" src="../assets/images/portfolio/techhub.png" alt="Techhub South"> -->
                                        <div class="row">
                                            <div class="col-sm-12 col-md-7">
                                                <a href="https://techhubsouth.web.app/" target="_blank">
                                                    <img class="img-fluid" src="../assets/images/portfolio/techhub.png" alt="Techhub South">
                                                </a>
                                            </div>
                                            <div class="col-sm-12 col-md-5 textik">
                                                <h3>Techhub South</h3>
                                                <p>Website for Techhub South, a community of tech startups and entrepreneurs. 
                                                    <br>3rd semester exam project for the course Multimedia design and Communication. Creating prototypes and coding the website.
                                                    <br>Built with Vue.js, Bootstrap, JavaScript, SCSS, and Firebase.</p>
                                                
                                                <a href="https://techhubsouth.web.app/" target="_blank" class="websites">
                                                    <button>Techhub South Website</button>
                                                </a>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="carousel-item">
                                        <!-- <img class="" src="../assets/images/portfolio/izone.png" alt="iZone Shop"> -->
                                        <div class="row">
                                            <div class="col-sm-12 col-md-7">
                                                <a href="https://zuzana-gabonayova.com/" target="_blank">
                                                    <img class="img-fluid" src="../assets/images/portfolio/izone.png" alt="iZone Shop">
                                                </a>
                                            </div>
                                            <div class="col-sm-12 col-md-5 textik">
                                                <h3>iZone Shop</h3>
                                                <p>Website for iZone Shop, an Apple reseller.
                                                    <br>This website is fully functional webshop.
                                                    <br>Built with WordPress, WooCommerce, PHP, and CSS.</p>
                                                <a href="https://zuzana-gabonayova.com/" target="_blank" class="websites">
                                                    <button>iZone Website</button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="carousel-item">
                                        <!-- <img class="" src="../assets/images/portfolio/trapholt.png" alt="Trapholt Museum"> -->
                                        <div class="row">
                                            <div class="col-sm-12 col-md-7">
                                                <a href="http://trapholt.6f.sk/" target="_blank">
                                                    <img class="img-fluid" src="../assets/images/portfolio/trapholt.png" alt="Trapholt Museum">
                                                </a>
                                            </div>
                                            <div class="col-sm-12 col-md-5 textik">
                                                <h3>Trapholt Museum</h3>
                                                <p>Website for Trapholt Museum, an art museum based in Kolding, Denmark.
                                                    <br>Website is focused on international students, it is a 1st semester project.
                                                    <br>Built with HTML5, Bootstrap, CSS, and JavaScript.</p>
                                                <a href="http://trapholt.6f.sk/" target="_blank" class="websites">
                                                    <button>Trapholt Museum Website</button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                </a> -->
                            </div>
                        </div>
                            
                    <!-- end of projects container  -->
                </div>
        </article>

    </section>

</template>